import { useUserContext } from '@fff-web/fff-utilities';
import { useState, useEffect } from 'react';
import { IPlanCode } from '../Interfaces';
import { IUserInfo } from 'packages/libs/fff-utilities/src/interfaces';
import useQueryParams from './useGetParams';

// This hook update the user data with the selected plan code
export default function useSelectedPlan() {
  const { userInfo } = useUserContext();
  const [selectedPlanCode, setSelectedPlanCode] = useState<
    IUserInfo | undefined
  >(undefined);
  const search = useQueryParams();

  const setPlanCode = (newPlanCode: IPlanCode) => {
    setSelectedPlanCode((prevPlan) => {
      return {
        ...prevPlan,
        user: {
          ...prevPlan.user,
          planCode: newPlanCode,
        },
      };
    });
  };

  useEffect(() => {
    if (search?.planCode) {
      const newPlanCode = search.planCode as IPlanCode;
      setPlanCode(newPlanCode);
      if (
        newPlanCode !== IPlanCode.SEASONAL &&
        newPlanCode !== IPlanCode.ANNUAL
      ) {
        setSelectedPlanCode(userInfo);
      }
      return;
    }

    if (userInfo.user) {
      setSelectedPlanCode(userInfo);
    }
  }, [userInfo, search?.planCode]);

  return {
    selectedPlanCode: selectedPlanCode?.user.planCode as IPlanCode,
    setPlanCode,
  };
}
